import axios from "axios";
import { baseApiUrl, httpRequest, getHttpHeaders } from "../ApiUtils";


const answerTypeApiUrl = `${baseApiUrl}/api/AnswerType`;

export async function getAnswerTypeList() {
    return await httpRequest(fetchAnswerTypeList.bind(this));
}

async function fetchAnswerTypeList() {
    let config = getHttpHeaders();
    return await axios.get(`${answerTypeApiUrl}`, config);
}

export async function getAnswerTypeById(id) {
    return await httpRequest(fetchAnswerTypeById.bind(this, id));
}

async function fetchAnswerTypeById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${answerTypeApiUrl}/${id}`, config);
}